
import moment from 'moment';
import humanizeDuration from 'humanize-duration';

const shortEnglishHumanizer = humanizeDuration.humanizer({
  language: 'shortEn',
  languages: {
    shortEn: {
      y: () => 'y',
      mo: () => 'mo',
      w: () => 'w',
      d: () => 'd',
      h: () => 'h',
      m: () => 'm',
      s: () => 's',
      ms: () => 'ms',
    }
  },
  maxDecimalPoints: 2
});

export class FilterUtil {

  public formatDeviceType(deviceType:string): string {
    return deviceType ? deviceType.replace(/([A-Z])/g, ' $1').toLowerCase() : deviceType;
  }

  public formatGroupId(groupId:string): string {
    return groupId ? groupId.split('.').pop() as string : '';
  }

  public tsToString(ts:number|undefined, format:'full'|'no-seconds'|'am-pm' = 'full'): string {

    if(!ts)
      return 'N/A';
  
    switch(format) {
      case 'full': return moment(ts).format('DD/MM/YYYY, HH:mm:ss');
      case 'no-seconds': return moment(ts).format('DD/MM/YYYY, HH:mm');
      case 'am-pm': return moment(ts).format('L LT');
      default:
        throw new Error(`Unrecognised time format: ${format}`);
    }
  }

  public tsToAgo(ts:number|undefined): string {
    return ts ? moment(ts).fromNow() : '';
  }

  public formatBytes(bytes:number|undefined): string {
    if(bytes === undefined)
      return 'N/A';
  
    const thresh = 1024;
    const units = ['kB','MB','GB','TB','PB','EB','ZB','YB']
  
    if(Math.abs(bytes) < 1024)
      return bytes + ' B';
  
    let u = -1;
    do {
        bytes /= thresh;
        ++u;
    } while(Math.abs(bytes) >= thresh && u < units.length - 1);
  
    return `${bytes.toFixed(2)} ${units[u]}`;
  
  }

  public formatDuration(duration:number): string {

    if(isNaN(duration) || duration === undefined)
      return 'N/A';
  
    return shortEnglishHumanizer(duration);
  }

  public maskFieldStars(field:string|undefined): string|undefined {  
    
    if(field === undefined)
      return field;

    if(field.length < 4)
      return field.split('').map(item => '*').join('');

    const maskSize = Math.floor(field.length / 4);

    return field
      .split('')
      .map((item, index) => index < maskSize || index >= field.length - maskSize ? item : '*')
      .join('');
  }

  public maskFieldEllipsis(field:string|undefined): string|undefined {

    if(field === undefined)
      return field;

    if(field.length < 4)
      return '...';

    const maskSize = Math.floor(field.length / 4);

    return field
      .split('')
      .map((item, index) => index < maskSize || index >= field.length - maskSize ? item : '*')
      .join('')
      .replace(/\*{3,}/g, '...')
      .replace(/\*{2}/g, '..');
  }

  public underscoreToSpaces(str:string):string {
    return str.replace(/_+/g, ' ');
  }

  public hexFormatter(source:string):string {
    let spacesRemoved = source.replace(/\s/g,"");
    let lastChar = spacesRemoved.substr(spacesRemoved.length-1)
    if (!/[a-f0-9]/.test(lastChar.toLowerCase())) {
      spacesRemoved = spacesRemoved.replace(lastChar,'')
    }
    return spacesRemoved.split('').map( (c:string, index:number) => (index % 2 !== 0) ? c + ' ' : c).join('').trim().toUpperCase();
  }

  public safeTruncate(src:string, len:number):string {
    if(!src)
      return src;

    if(src.length <= len)
      return src;
    
    return src.substring(0, len-3) + "...";
  }

  public smartFormatValue(value:any, decimals?:number):string {

    // if it's an integer
    if(Number(value) === value && value % 1 === 0)
      return value;

    // if it's a float
    if(Number(value) === value && value % 1 !== 0)
      return value.toFixed(decimals || 2);

    return value;
  }

}